// src/components/SmartImage.jsx
export default function SmartImage({
  src,
  alt,
  width,
  height,
  priority = false,
  className = "",
  ...rest
}) {
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      loading={priority ? "eager" : "lazy"}
      fetchpriority={priority ? "high" : "auto"}
      decoding="async"
      className={className}
      {...rest}
    />
  );
}